import ContentRectAnnotation from "@/modules/reader/annotations/builders/contentRect/ContentRectAnnotation"
import AbstractBuilder from "@/modules/reader/annotations/builders/AbstractBuilder";

class ContentRectBuilder {

    constructor() {

    }

    static get Builder() {
        class Builder extends AbstractBuilder {

            setToggleHintsMapping(data){
                this.toggleHintsIdMapping = data;
                return this;
            }

            build() {
                return new ContentRectAnnotation(this);
            }
        }
        return Builder;
    }
}

export default ContentRectBuilder